import { render, staticRenderFns } from "./FacebookRelogin.vue?vue&type=template&id=371c4d70"
import script from "./FacebookRelogin.vue?vue&type=script&lang=ts"
export * from "./FacebookRelogin.vue?vue&type=script&lang=ts"
import style0 from "./FacebookRelogin.vue?vue&type=style&index=0&id=371c4d70&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371c4d70')) {
      api.createRecord('371c4d70', component.options)
    } else {
      api.reload('371c4d70', component.options)
    }
    module.hot.accept("./FacebookRelogin.vue?vue&type=template&id=371c4d70", function () {
      api.rerender('371c4d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FacebookRelogin.vue"
export default component.exports